// extracted by mini-css-extract-plugin
export var button = "_k1-0";
export var donut = "_k1-1";
export var donutFill = "_k1-3";
export var donutTrack = "_k1-2";